import { useNavigate } from 'react-router-dom';
import EnvelopeIcon from 'assets/images/envelope-outlined.svg';
import styled from 'styled-components';
import { Badge, Button } from 'antd';
import { useInboxMessagesContext } from 'contexts/inboxMessages';

const MiddleIcon = styled.img`
  vertical-align: initial;
`;

const InboxButton = () => {
  const navigate = useNavigate();
  const { unreadMessageCount } = useInboxMessagesContext();
  return (
    <Button
      shape="circle"
      icon={
        <Badge dot={unreadMessageCount > 0} color="var(--error-color)">
          <MiddleIcon src={EnvelopeIcon} alt="inbox" />
        </Badge>
      }
      onClick={() => navigate('/inbox')}
    />
  );
};

export default InboxButton;
